import {addOperatorAction, editOperatorAction} from "./actions";

export default (state={} , action) => {
    switch (action.type) {
        case addOperatorAction.resultAction :
        case editOperatorAction.resultAction :
            return action.payload.data ;
        default :
            return state;
    }
}